<template>
  <div class="bg-white pb-0" :style="attributes.style">
    <div class="container">
      <div class="lg-container">
        <img
          class="lg-image"
          :src="`${IREALCONFIG.static_ressources}/${attributes.src}`"
          height="100%"
          width="100%"
        />

        <div v-for="hotspot in hotspotConfig.data" :key="hotspot.Title" @click="clickPoint">
          <div
            :style="`top: ${hotspot.y}%; left: ${hotspot.x}%;`"
            class="lg-hotspot lg-hotspot--top-left"
          >
            <div class="lg-hotspot__button"></div>
            <md-tooltip md-direction="right" class="hotspot__label">
              <h4>{{ hotspot.Title }}</h4>
              <p>{{ hotspot.Message }}</p>
            </md-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import componentMixin from "ireal-vue/mixins/component-mixin.js";
import inputComponentMixin from "ireal-vue/mixins/input-component-mixin.js";
//import VueHotspot from "vue-hotspot";

export default {
  name: "map-help-hover",
  mixins: [componentMixin, inputComponentMixin],
  //components: { VueHotspot },
  data() {
    return {
      hotspotConfig: {
        image: "",
        editable: false,
        interactivity: "hover",
        data: [],
        hotspotColor: "#ff9800",
        messageBoxColor: "#fafafa",
        textColor: "#333",
        opacity: 0.9,
      },
    };
  },
  async load() {
    //this.resize();
  },
  async mounted() {
    for (var message in this.config.elements) {
      var msg = this.config.elements[message];
      this.hotspotConfig.data.push({
        Message: msg.attributes.message,
        Title: msg.attributes.title,
        x: msg.attributes.x,
        y: msg.attributes.y,
        style: msg.attributes.style,
      });
    }
  },
  created() {},
  computed: {},
  methods: {
    clickPoint() {
      const selectHotspot = (e) => {
        const clickedHotspot = e.target.parentElement;
        const container = clickedHotspot.parentElement;

        // only include hotspots within same image to allow one open hotspot per image; change "container" to "document" to allow only one open hotspot for entire page:
        const hotspots = container.querySelectorAll(".lg-hotspot");
        hotspots.forEach((hotspot) => {
          if (hotspot === clickedHotspot) {
            hotspot.classList.toggle("lg-hotspot--selected");
          } else {
            hotspot.classList.remove("lg-hotspot--selected");
          }
        });
      };

      (() => {
        const buttons = document.querySelectorAll(".lg-hotspot__button");
        buttons.forEach((button) => {
          button.addEventListener("click", selectHotspot);
        });
      })();
    },
  },
};
</script>
